import { Subject } from 'rxjs';

const refreshCmControlChartsGrid = new Subject<boolean>();

const RiskAssessmentService = {
    refreshCmControlChartsGrid: (message: boolean) => {
        refreshCmControlChartsGrid.next(message);
    },
    onRefreshCmControlChartsGrid() {
        return refreshCmControlChartsGrid.asObservable();
    },
};

export default RiskAssessmentService;
